var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// Paths que requieren conversión a camelCase
var PATHS_REQUIRING_CAMELCASE = ["/addPassenger"];
/**
 * Convierte un string a camelCase
 * Ej: "Nombre Completo" -> "nombreCompleto", "número_de_pasajeros" -> "númeroDePasajeros"
 * También maneja PascalCase: "LastName" -> "lastName", "DocumentNumber" -> "documentNumber"
 */
function toCamelCase(str) {
    var normalized = str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // Elimina acentos
        .replace(/[^a-zA-Z0-9\s_-]/g, ""); // Elimina caracteres especiales
    // Inserta un espacio antes de mayúsculas para manejar PascalCase
    // Ej: "LastName" -> "Last Name", "DocumentNumber" -> "Document Number"
    var withSpaces = normalized.replace(/([a-z])([A-Z])/g, "$1 $2");
    return withSpaces
        .split(/[\s_-]+/) // Separa por espacios, guiones bajos o guiones
        .map(function (word, index) {
        if (index === 0) {
            return word.toLowerCase();
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
        .join("");
}
/**
 * Parsea una fecha en formato dd/mm/yyyy o yyyy-mm-dd
 */
function parseDate(dateStr) {
    // Intenta formato dd/mm/yyyy
    var ddmmyyyy = dateStr.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (ddmmyyyy) {
        var day = ddmmyyyy[1], month = ddmmyyyy[2], year = ddmmyyyy[3];
        return new Date(Number(year), Number(month) - 1, Number(day));
    }
    // Intenta formato yyyy-mm-dd
    var yyyymmdd = dateStr.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
    if (yyyymmdd) {
        var year = yyyymmdd[1], month = yyyymmdd[2], day = yyyymmdd[3];
        return new Date(Number(year), Number(month) - 1, Number(day));
    }
    // Fallback
    var date = new Date(dateStr);
    return isNaN(date.getTime()) ? null : date;
}
/**
 * Formatea una fecha a formato yyyy-mm-dd
 */
function formatDateToYYYYMMDD(dateStr) {
    var date = parseDate(dateStr);
    if (!date)
        return dateStr;
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, "0");
    var day = String(date.getDate()).padStart(2, "0");
    return "".concat(year, "-").concat(month, "-").concat(day);
}
/**
 * Calcula el número de días entre dos fechas
 */
function calculateDaysBetween(startDate, endDate) {
    var start = parseDate(startDate);
    var end = parseDate(endDate);
    if (!start || !end)
        return 0;
    var diffTime = Math.abs(end.getTime() - start.getTime());
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}
/**
 * Convierte las claves de un objeto a camelCase (recursivo)
 * También procesa arrays de objetos y elimina la propiedad "id" de cada item
 */
function convertKeysToCamelCase(obj) {
    var result = {};
    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
        var key = _a[_i];
        var camelKey = toCamelCase(key);
        var value = obj[key];
        if (Array.isArray(value)) {
            // Procesar arrays: convertir claves de cada objeto dentro del array
            result[camelKey] = value.map(function (item) {
                if (item && typeof item === "object" && !Array.isArray(item)) {
                    var converted = convertKeysToCamelCase(item);
                    return converted;
                }
                return item;
            });
        }
        else if (value && typeof value === "object") {
            result[camelKey] = convertKeysToCamelCase(value);
        }
        else {
            result[camelKey] = value;
        }
    }
    return result;
}
export function getDynamicFormsData(lsKey) {
    if (lsKey === void 0) { lsKey = "steps"; }
    var raw = localStorage.getItem(lsKey);
    if (!raw)
        return null;
    var data;
    try {
        data = JSON.parse(raw);
    }
    catch (_a) {
        return null;
    }
    if (!Array.isArray(data))
        return null; // esperamos un array
    // Detectar si hay algún paso con /addPassenger
    var hasAddPassenger = data.some(function (item) {
        return item && typeof item === "object" && item.pathUrl === "/addPassenger";
    });
    // Si hay /addPassenger, obtener el premium del Plan en /plan
    var premium = null;
    if (hasAddPassenger) {
        var planStep = data.find(function (item) { return item && typeof item === "object" && item.pathUrl === "/plan"; });
        if (planStep === null || planStep === void 0 ? void 0 : planStep.details) {
            var planDetails = planStep.details;
            var plan = planDetails.Plan;
            if ((plan === null || plan === void 0 ? void 0 : plan.price) !== undefined) {
                premium = Number(plan.price);
            }
        }
    }
    var detailsList = data
        .filter(function (item) {
        return item &&
            typeof item === "object" &&
            (item.pathUrl === "" ||
                item.pathUrl === "/initialInfo" ||
                item.pathUrl === "/add-business" ||
                item.pathUrl === "/calculate-premium" ||
                item.pathUrl === "/addPassenger") &&
            item.details &&
            typeof item.details === "object";
    })
        .map(function (item) {
        var details = item.details;
        // Si el flujo tiene /addPassenger, convertir claves a camelCase
        if (hasAddPassenger &&
            PATHS_REQUIRING_CAMELCASE.includes(item.pathUrl || "")) {
            return convertKeysToCamelCase(details);
        }
        return details;
    });
    if (detailsList.length === 0 && premium === null)
        return null;
    var result = Object.assign.apply(Object, __spreadArray([{}], detailsList, false));
    // Agregar premium si existe y el flujo tiene /addPassenger
    if (hasAddPassenger && premium !== null) {
        result.premium = premium;
        // Leer y agregar premiums por plan/rango desde details del step /plan
        var planPrefixes = ["A", "B", "C", "D"];
        var rangeSuffixes_1 = ["020", "2174", "7585"];
        var planStep = data.find(function (item) { return item && typeof item === "object" && item.pathUrl === "/plan"; });
        if (planStep === null || planStep === void 0 ? void 0 : planStep.details) {
            var planDetails_1 = planStep.details;
            planPrefixes.forEach(function (prefix) {
                rangeSuffixes_1.forEach(function (suffix) {
                    var key = "premium".concat(prefix).concat(suffix);
                    if (planDetails_1[key] !== undefined) {
                        result[key] = Number(planDetails_1[key]);
                    }
                });
            });
        }
        // Formatear fechaSalida y fechaRegreso a yyyy-mm-dd y calcular numberOfDays
        if (result.fechaSalida && typeof result.fechaSalida === "string") {
            result.fechaSalida = formatDateToYYYYMMDD(result.fechaSalida);
        }
        if (result.fechaRegreso && typeof result.fechaRegreso === "string") {
            result.fechaRegreso = formatDateToYYYYMMDD(result.fechaRegreso);
        }
        if (result.fechaSalida && result.fechaRegreso) {
            result.numberOfDays = calculateDaysBetween(result.fechaSalida, result.fechaRegreso);
        }
    }
    return result;
}
